import { useQuery, UseQueryOptions } from "react-query";
import { API_URL, APIError, APIResponse, get } from "../api";
import { IntlBookingDetail } from "../@types/intlFlightAggregator";

/**
 * Full detail for a single international booking — feeds the flight
 * details page. Separate from useInternationalFlightBookings (the list),
 * since the list endpoint only returns a lighter per-card summary.
 */
function useGetInternationalBookingDetail(
  bookingId: string | undefined,
  options?: Omit<UseQueryOptions<APIResponse<IntlBookingDetail>, APIError>, "queryKey" | "queryFn">
) {
  const query = useQuery<APIResponse<IntlBookingDetail>, APIError>({
    queryKey: ["international-booking-detail", bookingId],
    queryFn: () =>
      get(`${API_URL}/aviation/international/v2/bookings/${bookingId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }),
    enabled: !!bookingId,
    ...options,
  });

  return {
    booking: query.data?.data,
    fetchingBooking: query.isLoading,
    bookingError: query.error,
    refreshBooking: query.refetch,
  };
}

export default useGetInternationalBookingDetail;
